import gql from 'graphql-tag';

const templateSuratFragment = gql `
  fragment templateSuratFragment on TemplateSurat {
    id
    uuid
    keterangan
    nama
    kategori_surat{
      id
      nama
    },
    dokumen {
      uuid
      nama
      file_url
    }
  }     
`;

const ALL = gql `
  query all($perPage: Int!, $page: Int, $where: TemplateSuratWhereWhereConditions) {
    templateSurat(first: $perPage, page: $page, where: $where) {
      data {
        ...templateSuratFragment
      }
    }
  }
  ${templateSuratFragment}
`;

const FIND = gql `
  query find($where: TemplateSuratFindWhereWhereConditions) {
    templateSurat: templateSuratFind(where: $where) {
      ...templateSuratFragment
    }
  }
  ${templateSuratFragment}
`;

export { ALL, FIND};